import React from 'react';
import type { IconType } from 'react-icons';
import './NavIconTemplate.css';

interface NavProps {
  Icon?: IconType;
  title: string;
  onClick?: (e?: React.MouseEvent | React.KeyboardEvent) => void;
  className?: string;
}

const Nav: React.FC<NavProps> = ({ Icon, title, onClick, className }) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.(e);
    }
  };

  return (
    <div
      className={`nav${className ? ` ${className}` : ''}`}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      {Icon && <Icon className="icon" />}
      <h2>{title ? title : null}</h2>
    </div>
  );
};

export default Nav;
